export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14016.e514521f.jpg";